const SUPPORT_NAME_PATTERN = /^(aleh\s+maksimau|oleg\s+maximov)$/i
const SUPPORT_NAME_INLINE_PATTERN = /aleh\s+maksimau|oleg\s+maximov/gi

/**
 * Replaces known support agent names with "ZSH Support" for display on name badges.
 */
export function maskSupportName(name: string): string {
    if (!name) return name
    return SUPPORT_NAME_PATTERN.test(name.trim()) ? 'ZSH Support' : name
}

/**
 * Replaces all occurrences of known support agent names within message text.
 */
export function maskSupportNameInText(text: string): string {
    if (!text) return text
    return text.replace(SUPPORT_NAME_INLINE_PATTERN, 'ZSH Support')
}
